const PARENT_SELECTOR = ".js-quotations-with-highlights";
const QUOTATION_SELECTOR = ".js-quotation";
const QUOTATION_CHECKBOX_SELECTOR = "input[name='invoice[accepted]']";
const ACCEPTED_QUOTATION_CHECKBOX_SELECTOR = "input[name='invoice[accepted]']:checked";
const HIGHLIGHTED_CLASS = "highlighted";
const HIGHLIGHTED_SELECTOR = "." + HIGHLIGHTED_CLASS;

document.addEventListener("DOMContentLoaded", function () {
  const quotationsParents = document.querySelectorAll(PARENT_SELECTOR);
  if (quotationsParents.length < 1) return;
  const checboxes = document.querySelectorAll(QUOTATION_CHECKBOX_SELECTOR);

  // for each group of quotations, init highlight
  for (const parent of quotationsParents) {
    toggleAcceptedClass(parent);
  }

  // for all quotation, add event listener
  for (const checkbox of checboxes) {
    checkbox.addEventListener("change", (e) => toggleAcceptedClass(e.target.closest(PARENT_SELECTOR)));
  }
});

function toggleAcceptedClass(target) {
  removeAcceptedClass(target);

  // Différencier les checbox checked des autres
  const accepteds = target.querySelectorAll(ACCEPTED_QUOTATION_CHECKBOX_SELECTOR);

  // If there are accepted quotations, they are highlighted
  // otherwise the most recent quote is.
  if (accepteds.length > 0) {
    for (const accepted of accepteds) {
      const elt = accepted.closest(QUOTATION_SELECTOR);
      elt.classList.add(HIGHLIGHTED_CLASS);
    }
  } else {
    // Quotations are sorted by date, so the first one is the most recent
    const mostRecent = target.querySelector(QUOTATION_SELECTOR);
    if (mostRecent) {
      mostRecent.classList.add(HIGHLIGHTED_CLASS);
    }
  }
}

function removeAcceptedClass(parent) {
  const elts = parent.querySelectorAll(HIGHLIGHTED_SELECTOR);

  for (const elt of elts) {
    elt.classList.remove(HIGHLIGHTED_CLASS);
  }
}
